export default __webpack_public_path__ + "static/media/feature-icon-05.969b428e.svg";